import React, { Component } from 'react';
import { Banner } from '../../Components'
import feature from '../Home/screenshot-fast.jpg'
import '../Update/View.scss'
import { Link } from 'react-router-dom'

 
class Complete extends Component {

	componentDidMount() {
		window.scrollTo(0, 0)
	}

  render() {
	return (
		<div className="update-complete">

			<Banner title="Listing Sent" subtitle="Thank you for submitting your listing" />		

			<div className="page" >
				<div className="container text-center">


					<img src={feature} alt="feature" width="360"/>
					<h2>Thank you for your submission</h2>	

					<p>We have received your details. If you have any other questions, please call or email us directly.</p>

					
					<hr />
					
					<h3>Are you interested in using our <u>new</u> online service?</h3>
					<p>Learn more about what we offer on our features page</p>

					<Link to="/features" className="btn">Learn More</Link>

				</div>
			</div>
	  </div>
	)
  }
}

export default Complete


// WEBPACK FOOTER //
// ./src/Containers/Listing/Complete.js